import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3353890c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center mb-1" }

import { reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import type { FiltroEstadisticas } from "@/interfaces/Estadisticas";
import {
  filtroDesdeQuery,
  queryConFiltro,
} from "@/utils/estadisticasEjercitos";
import FiltrosEstadisticas from "@/components/Estadisticas/Ejercitos/FiltrosEstadisticas.vue";
import RankingEjercitos from "@/components/Estadisticas/Ejercitos/RankingEjercitos.vue";
import CrucesEjercitos from "@/components/Estadisticas/Ejercitos/CrucesEjercitos.vue";
import JugadoresEjercitos from "@/components/Estadisticas/Ejercitos/JugadoresEjercitos.vue";
import FichaEjercito from "@/components/Estadisticas/Ejercitos/FichaEjercito.vue";
import ComoSeCalcula from "@/components/Estadisticas/Ejercitos/ComoSeCalcula.vue";

type Seccion = "ejercitos" | "cruces" | "jugadores";

export default /*#__PURE__*/_defineComponent({
  __name: 'EstadisticasEjercitoView',
  setup(__props) {

const SECCIONES: Seccion[] = ["ejercitos", "cruces", "jugadores"];

const route = useRoute();
const router = useRouter();
const verComo = ref(false);

// La sección va en la URL (?seccion=cruces): al recargar se queda donde estaba. La ficha de un jugador enlaza aquí
// con ?seccion=jugadores&jugador=id
const pedida = String(route.query.seccion ?? "") as Seccion;
const seccion = ref<Seccion>(SECCIONES.includes(pedida) ? pedida : "ejercitos");
const abiertas = reactive({
  cruces: seccion.value === "cruces",
  jugadores: seccion.value === "jugadores",
});
const jugadorInicial = ref<number | null>(Number(route.query.jugador) || null);
watch(seccion, valor => {
  if (valor === "cruces") abiertas.cruces = true;
  if (valor === "jugadores") abiertas.jugadores = true;
  if (route.query.seccion !== valor)
    router.replace({ query: { ...route.query, seccion: valor } });
});

// Los filtros van en la URL: al recargar o al compartir el enlace se ven los mismos. Sin ellos se empieza por la
// temporada actual, con todos los puntos y sin amistosas; desde la ficha de un jugador, con todo, como cuenta sus
// partidas la ficha
const porDefecto: FiltroEstadisticas = jugadorInicial.value
  ? { temporadas: [], tramos: [], bando: null, amistosas: true }
  : {
      temporadas: [new Date().getFullYear()],
      tramos: [],
      bando: null,
      amistosas: false,
    };
const filtro = ref<FiltroEstadisticas>(
  filtroDesdeQuery(route.query, porDefecto)
);
watch(
  filtro,
  valor => router.replace({ query: queryConFiltro(route.query, valor) }),
  { deep: true }
);

const verFicha = ref(false);
const ejercitoVisto = ref<string | null>(null);
const abrirFicha = (ejercito: string) => {
  ejercitoVisto.value = ejercito;
  verFicha.value = true;
};

// Desde la ficha, un rival lleva a su cruce
const cruceInicial = ref<{ ejercito: string; rival: string } | null>(null);
const verCruce = (cruce: { ejercito: string; rival: string }) => {
  verFicha.value = false;
  cruceInicial.value = { ...cruce };
  seccion.value = "cruces";
};

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "estadisticas text-left" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_chip_group, {
        modelValue: seccion.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((seccion).value = $event)),
        mandatory: "",
        "selected-class": "text-primary",
        class: "mb-1 secciones"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_chip, {
            value: "ejercitos",
            filter: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ejércitos")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, {
            value: "cruces",
            filter: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cruces")
            ]),
            _: 1
          }),
          _createVNode(_component_v_chip, {
            value: "jugadores",
            filter: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Jugadores")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          variant: "text",
          size: "small",
          color: "primary",
          class: "text-none",
          "prepend-icon": "mdi-information-outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (verComo.value = !verComo.value))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ¿Cómo se calcula? ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (verComo.value)
            ? (_openBlock(), _createBlock(_component_v_card, {
                key: 0,
                variant: "tonal",
                class: "pa-4 mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(ComoSeCalcula)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(FiltrosEstadisticas, {
        modelValue: filtro.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filtro).value = $event)),
        "con-bando": seccion.value === 'ejercitos'
      }, null, 8, ["modelValue", "con-bando"]),
      _withDirectives(_createVNode(RankingEjercitos, {
        filtro: filtro.value,
        onVer: abrirFicha
      }, null, 8, ["filtro"]), [
        [_vShow, seccion.value === 'ejercitos']
      ]),
      (abiertas.cruces)
        ? _withDirectives((_openBlock(), _createBlock(CrucesEjercitos, {
            key: 0,
            filtro: filtro.value,
            inicial: cruceInicial.value
          }, null, 8, ["filtro", "inicial"])), [
            [_vShow, seccion.value === 'cruces']
          ])
        : _createCommentVNode("", true),
      (abiertas.jugadores)
        ? _withDirectives((_openBlock(), _createBlock(JugadoresEjercitos, {
            key: 1,
            filtro: filtro.value,
            jugadorInicial: jugadorInicial.value,
            onVer: abrirFicha
          }, null, 8, ["filtro", "jugadorInicial"])), [
            [_vShow, seccion.value === 'jugadores']
          ])
        : _createCommentVNode("", true),
      _createVNode(FichaEjercito, {
        modelValue: verFicha.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((verFicha).value = $event)),
        ejercito: ejercitoVisto.value,
        filtro: filtro.value,
        onCruce: verCruce
      }, null, 8, ["modelValue", "ejercito", "filtro"])
    ]),
    _: 1
  }))
}
}

})